import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isSignin: false,
  user: {},
  loading: false,
  errorMessage: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signInStart: (state) => {
      state.loading = true;
      state.errorMessage = null;
    },
    signInSuccess: (state, action) => {
      state.user = action.payload;
      state.isSignin = true;
      state.loading = false;
      state.errorMessage = null;
    },
    signOutSuccess: (state) => {
      state.user = {};
      state.isSignin = false;
      state.loading = false;
      state.errorMessage = null;
    },
    signInFail: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
    },
    updateUser: (state, action) => {
      state.user = {...state.user, ...action.payload};
    }
  },
});

export const { signInSuccess, signOutSuccess, signInFail, signInStart,updateUser } = authSlice.actions;

export default authSlice.reducer;
